import { render, staticRenderFns } from "./barcharts.vue?vue&type=template&id=13f7eacf&scoped=true&"
import script from "./barcharts.vue?vue&type=script&lang=js&"
export * from "./barcharts.vue?vue&type=script&lang=js&"
import style0 from "./barcharts.vue?vue&type=style&index=0&id=13f7eacf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7eacf",
  null
  
)

export default component.exports